// assets
import { FileExcelFilled, FileProtectOutlined } from '@ant-design/icons';

// icons
const icons = { FileExcelFilled, FileProtectOutlined };

// ==============================|| MENU ITEMS - RECAUDO ||============================== //

const recaudo = {
  id: 'group-recaudo',
  title: 'Reportes',
  type: 'group',
  children: [
    {
      id: 'recaudo',
      title: 'Recaudo',
      type: 'item',
      url: '/recaudo',
      icon: icons.FileProtectOutlined,
      breadcrumbs: false
    },
    {
      id: 'recaudo-por-fecha',
      title: 'Recaudo por fecha',
      type: 'item',
      url: '/recaudo-por-fecha',
      icon: icons.FileExcelFilled,
      breadcrumbs: false
    },
    {
      id: 'recaudo-por-cliente',
      title: 'Recaudo por cliente',
      type: 'item',
      url: '/recaudo-por-cliente',
      icon: icons.FileProtectOutlined,
      breadcrumbs: false
    },
    {
      id: 'recaudo-por-ruta',
      title: 'Recaudo por ruta',
      type: 'item',
      url: '/recaudo-por-ruta',
      icon: icons.FileExcelFilled,
      breadcrumbs: false
    }
  ]
};

export default recaudo;
